import { useState } from 'react';
import { toast } from 'react-toastify';
import { generateInvoiceSharedLink } from '../../../../../../services/invoices';
import { getDate } from '../../../../../../utils/dateUtils';
import Modal from '../../../../../../component/modal/Modal';
import InputField from '../../../../../../component/form/FormInput';
import Button from '../../../../../../component/ui/Button';

const InvoiceShareLinkModal = ({ isShareLinkModelOpen, setShareLinkModelOpen, invoiceId }) => {
	const [date, setDate] = useState('');
	const [url, setUrl] = useState('');
	const [isGenerateUrl, setIsGenerateUrl] = useState(false);
	async function handleGenerateUrl() {
		try {
			var body = {
				expiry_date: getDate(date),
				invoice_id: invoiceId,
			};
			var { invoice } = await generateInvoiceSharedLink(body);
			const fullUrl = window.location.href;
			if (fullUrl.includes('localhost:3000')) {
				setUrl(`localhost:3000/sales/invoices/share/${invoice.share_id}`);
			} else if (fullUrl.includes('dev.pharmnex.app')) {
				setUrl(`https://dev.pharmnex.app/sales/invoices/share/${invoice.share_id}`);
			} else if (fullUrl.includes('uat.pharmnex.app')) {
				setUrl(`https://uat.pharmnex.app/sales/invoices/share/${invoice.share_id}`);
			}
			setIsGenerateUrl(true);
		} catch (error) {
			toast.error(error.message ?? 'Something went wrong!');
		}
	}

	async function handleCopyUrl() {
		try {
			await navigator.clipboard.writeText(url);
		} catch (err) {
			toast.error('Failed to copy!');
		}
	}

	return (
		<Modal
			className="deleteVendorsModal"
			title="Share Invoice Link"
			isOpen={isShareLinkModelOpen}
			onClose={() => {
				setShareLinkModelOpen(false);
			}}
			cancelButton={() => {
				setShareLinkModelOpen(false);
			}}
		>
			<div
				style={{
					textAlign: 'left',
					display: 'flex',
					flexDirection: 'column',
					padding: '10px',
				}}
			>
				<InputField
					label="Link Expiration Date"
					placeholder="Enter Date"
					type="date"
					autoFocus={true}
					value={date}
					onChange={(value) => {
						setDate(value);
					}}
				/>
				<p style={{ color: '#555B67', fontSize: '14px', fontWeight: '400' }}>
					By default, the link is set to expire 90 days from today
				</p>
				{isGenerateUrl && (
					<InputField
						label=""
						placeholder="https://www.w3.org/Provider/Style/dummy.html"
						type="text"
						value={url}
						onChange={(value) => {
							setUrl(value);
						}}
					/>
				)}
			</div>

			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					marginLeft: '10px',
					justifyContent: 'start',
				}}
			>
				<Button
					type="button"
					className="mt-0 btn-primary add-pro"
					button={isGenerateUrl ? 'Copy Url' : 'Generate Link'}
					onClick={() => {
						if (isGenerateUrl) {
							handleCopyUrl();
						} else {
							handleGenerateUrl();
						}
					}}
				/>
			</div>
		</Modal>
	);
};
export default InvoiceShareLinkModal;
